import 'firebase/compat/firestore';

export class VenueVolatalityItem {
    currentInjury: string;
    medianPaidLoss:number;
    state:string;
    county:string;
    venueVolatility:string;
}